import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/issuecleaningitem',
  component: () => import('@views/IssueCleaningItem/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'cleaning.index',
      component: () => import('@/components/IssueCleaningItem/IssueCleaningItem')
    },
    {
      path: 'cleaning/receive',
      name: 'cleaning.receive',
      component: () => import('@/components/IssueCleaningItem/IssueReceiveItem')
    },
    {
      path: 'cleaning/release/item/:id',
      name: 'cleaning.form.release',
      component: () => import('@/components/IssueCleaningItem/IssueItem'),
    },
    {
      path: 'cleaning/receive/item/:id',
      name: 'cleaning.form.receive',
      component: () => import('@/components/IssueCleaningItem/IssueItemReceive'),
    },
  ]
}
